import Money from "components/general/Forms/Money";
import React, { useContext } from "react";
import { Label } from "structure/Document";
import { ContextCatalogueAdmin } from "../..";
import { Controller } from "react-hook-form";

/**
 * Render the unti cost input
 * @param {import("../types").NumberInput} props - Props
 * @returns {JSX.Element}
 */
export default function UnitCost(props) {
  const hook = useContext(ContextCatalogueAdmin);

  const reactHookForm =
    props.operation === "add" ? hook.formAdd : hook.formEdit;

  return (
    <div>
      <Label>Costo unitario</Label>

      <Controller
        render={({ onChange , value }) => (
          <Money
            value={value}
            name="unitCost"
            maxDecimals={2}
            placeholder="Escribe aquí"
            onChange={onChange}
            {...props}
          />
        )}
        name="unitCost"
        control={reactHookForm.control}
        defaultValue={0}
      />

      <p className="text-danger font-weight-bold">
        {reactHookForm.errors?.unitCost?.message}
      </p>
    </div>
  );
}
